import { useRouter } from "expo-router"
import React from "react"
import { TouchableOpacity, View } from "react-native"

import { useCommunityEvents } from "@/queries/events"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H3, Small } from "@/components/standard/BFText"
import IconCalendar from "phosphor-react-native/src/icons/Calendar"
import IconMapPin from "phosphor-react-native/src/icons/MapPin"
import { formatEventDateTime } from "@/screens/events/utils"

export const EventWidget: React.FC = () => {
  const router = useRouter()

  // Fetch events data
  const { data: eventsData } = useCommunityEvents()

  // Get the most recent event (first in the list)
  const latestEvent = eventsData?.[0]

  // If there's no event data or still loading, don't render the widget
  if (!latestEvent) return null

  // Handler for the button press
  const handlePress = () => {
    if (latestEvent?.id) {
      router.push(`/events/?id=${latestEvent.id}`)
    }
  }

  // Event tag based on the format type
  const eventTag =
    latestEvent?.eventType === "IN_PERSON" ? "IN PERSON" : "VIRTUAL"

  return (
    <TouchableOpacity
      testID={"event-widget"}
      activeOpacity={0.7}
      onPress={handlePress}
      className="overflow-hidden w-[332px] rounded-lg bg-[rgba(40,101,136,0.5)] my-2 shadow-sm"
    >
      <Vertical className="p-4 gap-2">
        {/* Badge */}
        <View className="self-start rounded px-1.5 py-0.5 bg-teal">
          <Small color="primary" className="font-figtree-extrabold uppercase">
            {eventTag}
          </Small>
        </View>

        {/* Event Title */}
        <View>
          <H3 color="white" className="font-figtree-extrabold">
            {latestEvent?.name}
          </H3>
        </View>

        {/* Date and Location Container */}
        <Horizontal className="flex-wrap gap-3">
          {/* Date and time */}
          <Horizontal className="items-center gap-1">
            <IconCalendar size={16} color="#FFFFFF" weight="fill" />
            <Small color="white" className="font-spacegrotesk">
              {formatEventDateTime(latestEvent?.startTime)}
            </Small>
          </Horizontal>

          {/* Location */}
          <Horizontal className="items-center gap-1">
            <IconMapPin size={16} color="#FFFFFF" weight="fill" />
            <Small color="white" className="font-spacegrotesk">
              {latestEvent?.address}
            </Small>
          </Horizontal>
        </Horizontal>
      </Vertical>
    </TouchableOpacity>
  )
}
